import React from 'react';
import { NavTabStyled } from './navTab.styled';

interface NavTabProps {
  size?: 'small' | 'default';
  active?: boolean;
  inverse?: boolean;
  semiActive?: boolean;
  activeIconColor?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  children?: React.ReactChild | React.ReactChild[];
}

const NavTab = ({ children, ...rest }: NavTabProps) => {
  return <NavTabStyled {...rest}>{children}</NavTabStyled>;
};

export default NavTab;
